if (!customElements.get('tooltip-button')) {
  class TooltipButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.tippyInstance = null;
    }

    connectedCallback() {
      this.tippyInstance = tippy(this.button, {
        theme: 'light',
        maxWidth: 200,
        allowHTML: true,
        trigger: 'manual',
        interactive: true,
        appendTo: () => document.body,
        hideOnClick: true,
        onShow(instance) {
          instance.popper.style.pointerEvents = 'auto';
        }
      });

      // Manual trigger to work around Safari + Swiper issues
      const showTooltip = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.tippyInstance) {
          if (this.tippyInstance.state.isVisible) {
            this.tippyInstance.hide();
          } else {
            this.tippyInstance.show();
          }
        }
      };

      // Listen to both click and touchend for better Safari support
      this.button.addEventListener('click', showTooltip);
      this.button.addEventListener('touchend', showTooltip);

      // Close tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (this.tippyInstance && this.tippyInstance.state.isVisible) {
          if (!this.button.contains(e.target) && !this.tippyInstance.popper.contains(e.target)) {
            this.tippyInstance.hide();
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.tippyInstance) {
        this.tippyInstance.destroy();
      }
    }
  }

  customElements.define('tooltip-button', TooltipButton);
}
